import { render, staticRenderFns } from "./SoftwareModal.vue?vue&type=template&id=368abc99&scoped=true&"
import script from "./SoftwareModal.vue?vue&type=script&lang=js&"
export * from "./SoftwareModal.vue?vue&type=script&lang=js&"
import style0 from "./SoftwareModal.vue?vue&type=style&index=0&id=368abc99&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368abc99",
  null
  
)

export default component.exports